import B1 from "../../../Images/New/ImageView/1.jpg";
import B2 from "../../../Images/New/ImageView/2.jpg";
import B3 from "../../../Images/New/ImageView/3.jpg";
import B4 from "../../../Images/New/ImageView/4.jpg";
import B5 from "../../../Images/New/ImageView/5.jpg";
import B6 from "../../../Images/New/ImageView/6.jpg";
import B7 from "../../../Images/New/ImageView/7.jpg";
import B8 from "../../../Images/New/ImageView/8.jpg";
import B9 from "../../../Images/New/ImageView/9.png";

const moduleData = [
  {
    name: "ANALYSIS REPORTS",
    back: B1,
  },
  {
    name: " ASSESSEE DASHBOARD ",
    back: B2,
  },
  {
    name: "  CLIENT CREATION",
    back: B3,
  },
  {
    name: " GST CMP 08",
    back: B4,
  },
  {
    name: " GST E-INVOICE",
    back: B9,
  },
  {
    name: " GST E-WAY BILL",
    back: B5,
  },
  {
    name: " ONLINE TOOL",
    back: B6,
  },
  {
    name: " RETURN SUMMARY",
    back: B7,
  },
  {
    name: " GSTR-4",
    back: B8,
  },
];

export default moduleData;

